import React from 'react';
import Bullets from 'slickpay/common/Bullets.component';
import DockFooter from 'slickpay/online/DockFooter.component';
import FaqPannel from 'slickpay/online/FaqPannel.component';
import ThreeCards from 'slickpay/online/ThreeCards.component';
import Intro from 'slickpay/ordered/Intro.component';
import SlickPayTopContainer from 'slickpay/ordered/SlickPayTopContainer.component';
import StatusBanner from 'slickpay/ordered/StatusBanner.component';
import StepsBanner from 'slickpay/ordered/StepsBanner.component';

import IMG_GIF from 'assets/slickpay-splash/tip/tiping-animation-sm.gif'; //
import Badge from 'components/generic/Badge.component';
import { useTranslation } from 'providers/GILT.provider';
import C from 'utils/values/constant.util';

import CN from './OrderedLayout.module.scss';

const OrderedLayout = () => {
  const { t } = useTranslation();

  const DATA_TIPS = C([t('slickPay.ordered.tip1'), t('slickPay.ordered.tip2'), t('slickPay.ordered.tip3'), t('slickPay.ordered.tip4')]);

  return (
    <div data-bem="OrderedLayout" className={CN.component}>
      <SlickPayTopContainer />
      <StatusBanner />
      <div data-bem="OrderedLayout__wrap" className={CN.wrap}>
        <div className={CN.container}>
          <StepsBanner />
          <Intro />
        </div>
      </div>
      <div data-bem="OrderedLayout__wrap" className={CN.wrap}>
        <div data-bem="OrderedLayout__card" className={CN.card}>
          <div className={CN.cardImage}>
            <div className={CN.imgContainer}>
              <img src={IMG_GIF} alt="" className={CN.img} />
            </div>
          </div>
          <div className={CN.cardText}>
            <div className={CN.inline}>
              <Badge name={t('slickPay.ordered.tipsBadge')} variant="fine" />
            </div>
            <div className={CN.cardTitle}>
              {t('slickPay.ordered.integratedTipping')}
              <span className={CN.textBreak}>{t('slickPay.ordered.noFees')}</span>
            </div>
            <Bullets data={DATA_TIPS} />
          </div>
        </div>
      </div>

      <div data-bem="OrderedLayout__wrap" className={CN.wrap}>
        <FaqPannel />
        <DockFooter />
        <ThreeCards />
      </div>
    </div>
  );
};

export default OrderedLayout;
